import React, { HTMLAttributes } from 'react';
import cn from 'classnames';

interface AwardPaymentPageContainerProps extends HTMLAttributes<HTMLDivElement> {}

const AwardPaymentPageContainer: React.FC<AwardPaymentPageContainerProps> = ({ className, children, ...props }) => {
  return (
    <div className={cn('mx-auto w-[90%]', className)} {...props}>
      {children}
    </div>
  );
};

export default AwardPaymentPageContainer;
